import {sendEmail} from '../../../../third-party/mailgun/services/mailgunService'

export const attemptSendEmail = (email) => {
    return sendEmail(email)
}





// WEBPACK FOOTER //
// ./src/platform/notifications/email/services/emailService.js